import { Routes } from '@angular/router';
import { LoginGuard } from './guards/login.guard';

export const routes: Routes = [
	{
		path: '',
		redirectTo: 'home',
		pathMatch: 'full'
	},
	{
		path: 'home',
		loadComponent: () => import('@pages/home/home.page').then((m) => m.HomePage),
		canActivate: [LoginGuard]
	},
	{
		path: 'start',
		loadComponent: () => import('@pages/start/start.page').then((m) => m.StartPage)
	},
	{
		path: 'recover',
		loadComponent: () => import('@pages/recover/recover.page').then((m) => m.RecoverPage)
	},
	{
		path: 'auth/set-password/:token',
		loadComponent: () => import('@pages/set-password/set-password.page').then((m) => m.SetPasswordPage)
	},
	{
		path: 'settings',
		loadComponent: () => import('@pages/settings/settings.page').then((m) => m.SettingsPage)
	},
	{
		path: 'terminal',
		loadComponent: () => import('@pages/terminal/terminal.page').then((m) => m.TerminalPage)
	},
	{
		path: 'password',
		loadComponent: () => import('@pages/password/password.page').then((m) => m.PasswordPage)
	},
	{
		path: 'info',
		loadComponent: () => import('@pages/info/info.page').then((m) => m.InfoPage)
	},
	{
		path: 'menu',
		loadComponent: () => import('@pages/menu/menu.page').then((m) => m.MenuPage)
	},
	{
		path: 'language',
		loadComponent: () => import('@pages/language/language.page').then((m) => m.LanguagePage)
	},
	{
		path: 'movements',
		loadComponent: () => import('@pages/movements/movements.page').then((m) => m.MovementsPage)
	},
	{
		path: 'payment-resume',
		loadComponent: () => import('@pages/payment-resume/payment-resume.page').then((m) => m.PaymentResumePage)
	},
	{
		path: 'payment-status/:id',
		loadComponent: () => import('@pages/payment-status/payment-status.page').then((m) => m.PaymentStatusPage)
	},
	{
		path: 'images',
		loadComponent: () => import('./pages/images/images.page').then((m) => m.ImagesPage)
	},
	{
		path: 'movements/:id',
		loadComponent: () => import('./pages/movement/movement.page').then((m) => m.MovementPage)
	},
	{
		path: 'payment-thanks',
		loadComponent: () => import('./pages/payment-thanks/payment-thanks.page').then((m) => m.PaymentThanksPage)
	},
	{
		path: 'cash-delivery',
		loadComponent: () => import('./pages/cash-delivery/cash-delivery.page').then((m) => m.CashDeliveryPage)
	},
	{
		path: 'search-accommodation',
		loadComponent: () => import('@pages/search-accommodation/search-accommodation.page').then((m) => m.SearchAccommodationPage)
	},
	{
		path: 'payment-plan',
		loadComponent: () => import('@pages/payment-plan/payment-plan.page').then((m) => m.PaymentPlanPage)
	}
];
